module.exports = __webpack_public_path__ + "img/symbol_1.1db4805a.png";